import { useState, useCallback } from "react";
import Emojify from "~/components/shared/Emojify";
import Icon from "~/components/shared/Icon";

type Props = {
  message: string;
  urlParam?: string;
};

const SuccessNotice = (props: Props) => {
  const [dismissed, setDismissed] = useState<boolean>(false);

  // @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
  const handleDismiss = useCallback(() => {
    setDismissed(true);

    if (props.urlParam) {
      const url = new URL(window.location.href);
      url.searchParams.delete(props.urlParam);
      history.pushState({}, "", url.toString());
    }
  });

  if (dismissed) {
    return null;
  }

  return (
    <div
      role="banner"
      className="border-lime mb-4 rounded border"
      style={{
        backgroundColor: "#E8FAF2",
        boxShadow: "0px 2px 8px #14CC8033",
      }}
    >
      <div className="mx-3 my-1 flex items-center">
        <div className="flex min-w-0 flex-auto flex-wrap justify-end">
          <div className="flex min-w-0 flex-auto items-center" style={{ flexBasis: 300 }}>
            <Emojify
              text="🎉"
              className="ml-1 mr-3 flex-none leading-tight"
              style={{ fontSize: 40 }}
              title="Success!"
            />
            <div className="mr-3 min-w-0 flex-auto py-1">
              <strong>Success!</strong> {props.message}
            </div>
          </div>
        </div>
        <button
          className="btn px-4 py-5"
          style={{ marginRight: -15 }}
          onClick={handleDismiss}
          disabled={dismissed}
          aria-label="Dismiss notice"
        >
          <Icon className="mx-auto" icon="close" title="Close" />
        </button>
      </div>
    </div>
  );
};

export default SuccessNotice;
